import { useMutation, useQuery, useQueryClient} from 'react-query';
import { checkAnalytics, Subscribe } from '../../api/common';

export const ANALYTICS_QUERY_KEY = 'analytics';
export const SUBSCRIBE_QUERY_KEY = 'subscribe';

export const useCheckAnalytics = (params, enabled) => {
    const query = useQuery(ANALYTICS_QUERY_KEY, async () => checkAnalytics(params), {
        enabled,
        refetchOnWindowFocus: false,
    });
    return query;
};

export const useSubscribe = () => {
    const queryClient = useQueryClient();
    const mutation = useMutation(({ email }: { email: any }) => Subscribe({ email }));
    return {
        subscribe: async (email) => {
            await mutation.mutateAsync({ email });
            queryClient.invalidateQueries(SUBSCRIBE_QUERY_KEY);
        },
        isError: mutation.isError,
        loading: mutation.isLoading,
        isSuccess: mutation.isSuccess,
        responseMessage: mutation.data, // Get the response data from the mutation
        errorMessage: mutation.error, 
    };
};


